module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.af7ae505.woff2";